export class PushCartError extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['close']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onItemClick.bind(this))

    window.setTimeout(() => {
      this.remove()
    }, 2000)
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onItemClick (e) {
    this.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('push-cart-error')) {
  customElements.define('push-cart-error', PushCartError)
}
